import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Cliente } from "@/shared/types/cliente";

export async function checkCliente(numDocumento: string): Promise<Cliente | null> {
    await sleep(1000);
    const { data } = await api.get("clientes/check/" + numDocumento);
    return data ? data : null;
}

export function useCheckClienteQuery(numDocumento: string, queryConfig: QueryConfig<Cliente | null> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await checkCliente(numDocumento),
        queryKey: ["clientes", "check", numDocumento],
    })
}

export interface CheckClienteQueryProps {
    numDocumento: string,
    queryConfig?: QueryConfig<Cliente | null>,
    children?: (queryResult: QueryResult<Cliente | null>) => ReactNode
}

export function CheckClienteQuery({
    numDocumento,
    children,
    queryConfig
}: CheckClienteQueryProps) {
    const queryResult = useCheckClienteQuery(numDocumento, queryConfig);
    return children && children(queryResult);
}